<app-debugger-group>
  <app-debugger title="Projects" [json]="projects"></app-debugger>
  <app-debugger title="Project Lists" [json]="projectLists$"></app-debugger>
  <app-debugger
    title="Display Projects"
    [json]="displayProjects$"
  ></app-debugger>
</app-debugger-group>
<app-list
  [projectLists]="projectLists$ | async"
  (openProject)="openProject.emit($event)"
></app-list>
@if (!loading && (displayProjects$ | async)?.length === 0) {

<h3>No projects.</h3>
@if (total > 0) {
<h4>
  (There are {{ total }} projects which are currently hidden. To display them,
  disable/change filtering.)
</h4>
} }

<mat-paginator
  fxFlexAlign="end"
  [pageSizeOptions]="[5, 10, 20, 50, 100, 200]"
  [pageSize]="(pageStats$ | async).pageSize"
  [pageIndex]="(pageStats$ | async).pageIndex"
  showFirstLastButtons="true"
  (page)="pageChange$$.next($event)"
  [length]="projects.length"
>
</mat-paginator>
